import { APARTMENT_STATUS } from '../../config/consts';
import { IApartment, IApartmentBase } from '../apartments/store';
import { FERoles, TUuid } from '../commonTypes';
import { IUser } from '../user/store';

export enum ApartmentUserRole {
  APARTMENT_USER = 'APARTMENT_USER',
  APARTMENT_ADMIN_INHERITED = 'APARTMENT_ADMIN_INHERITED',
  APARTMENT_ADMIN = 'APARTMENT_ADMIN',
  APARTMENT_LOGIN_LESS = 'APARTMENT_LOGIN_LESS',
  APARTMENT_PMS_LOGIN_LESS = 'APARTMENT_PMS_LOGIN_LESS',
  APARTMENT_GUEST = 'APARTMENT_GUEST',
}

export type ApartmentUser = Omit<IUser, 'apartments' | 'groups' | 'role' | 'email' | 'firstName'> & {
  apartmentAccess?: boolean;
  enabled: boolean;
  email?: string;
  id: number;
  role: ApartmentUserRole;
  firstName?: string;
  validFrom?: string;
  validTo?: string;
  phoneNumber?: string;
  siteBleActive?: boolean;
};

export interface EnrichedApartmentUser extends ApartmentUser {
  apartments: {
    id: number;
  }[];
}

export type ApartmentUserWithCallingStatus = {
  mobileVideoActivated: boolean;
  gsmCalls?: boolean;
  siteGsmCalls?: boolean;
} & ApartmentUser;

export interface IAggregatedApartmentUsers extends Omit<IApartment, 'floor' | 'label' | 'name'> {
  bluetoothEnabled: boolean;
  devicesCount: number;
  paidDevicesCount: number;
  paidDevicesLimit: number;
  apartmentMobileVideoState: keyof typeof APARTMENT_STATUS;
  contactLabels: string[];
  users: ApartmentUserWithCallingStatus[];
  site: { id: number; name: string; gsmCalls?: boolean };
  company: { id: number };
  name?: string;
}

export interface ICreateApartmentUser {
  appAccessActivated: boolean;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  gsmCalls: boolean;
  mobileVideoActivated: boolean;
  role?: FERoles;
}

export type AccessGroupName = string;

export interface IAccessGroup {
  id: TUuid;
  name: AccessGroupName;
  description: string;
  siteId: TUuid;
}

export interface IApartmentWithAccessGroups extends IApartmentBase {
  siteId: TUuid;
  coreId: TUuid;
  devicesCount: number;
  groups: IAccessGroup[];
}
